
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class IndexationProfileDialog extends SiteEntityDialog<IndexationProfileRow, any> {
        protected getFormKey() { return IndexationProfileForm.formKey; }
        protected getIdProperty() { return IndexationProfileRow.idProperty; }
        protected getLocalTextPrefix() { return IndexationProfileRow.localTextPrefix; }
        protected getNameProperty() { return IndexationProfileRow.nameProperty; }
        protected getService() { return IndexationProfileService.baseUrl; }
        protected getDeletePermission() { return IndexationProfileRow.deletePermission; }
        protected getInsertPermission() { return IndexationProfileRow.insertPermission; }
        protected getUpdatePermission() { return IndexationProfileRow.updatePermission; }

        protected form = new IndexationProfileForm(this.idPrefix);

        constructor() {
            super();

            this.form.Prices.readOnly = true;
            this.form.Returns.readOnly = true;
            this.form.CompositeConstituents.readOnly = true;
            this.form.ConstituentReturns.readOnly = true;

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected arrange() {
            super.arrange();
            var availHeight = $(window).height() - 210;
            this.form.SecurityList.element.css('height', Math.max(150, availHeight - 330) + 'px').trigger('layout');
            var tabGridHeight = Math.max(150, availHeight) + 'px';
            this.form.Prices.element.css('height', tabGridHeight).trigger('layout');
            this.form.Returns.element.css('height', tabGridHeight).trigger('layout');
            this.form.CompositeConstituents.element.css('height', tabGridHeight).trigger('layout');
            this.form.ConstituentReturns.element.css('height', tabGridHeight).trigger('layout');
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.form.Prices.indexationProfileCode = this.entityId;
            this.form.Returns.indexationProfileCode = this.entityId;
            this.form.CompositeConstituents.indexationProfileCode = this.entityId;
            this.form.ConstituentReturns.indexationProfileCode = this.entityId;
            this.form.SecurityList.indexationProfileCode = this.entityId;
        }

        protected getCloningEntity() {
            var entity = super.getCloningEntity();

            if (entity.SecurityList) {
                entity.SecurityList = Q.deepClone(entity.SecurityList);
                var securityProps = Q.getForm(IndexationProfileSecurityForm.formKey);

                for (var security of entity.SecurityList) {
                    removeSystemFields(security, securityProps);
                }
            }

            entity.CloningIndexationProfileCode = this.entity.IndexationProfileCode;

            return entity;
        }
    }
}